/* eslint-disable no-unused-vars */
import { SaleProduct, ProductType } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    Leads: [],
    count: 0,
  },
  actions: {
    async fetchProducts({ commit }, options) {
      const products = await SaleProduct.fetch({ ...options, _sort: 'grade:desc,productType.index:asc' })
      return products
    },
    async fetchProduct({ commit }, productId) {
      const product = await SaleProduct.fetchOne(productId)
      return product
    },
    async createProduct({ commit }, data) {
      const newProd = await SaleProduct.create(data)
      return newProd
    },
    async updateProduct({ commit }, { id, ...data }) {
      const updatedProd = await SaleProduct.update(id, { ...data })
      return updatedProd
    },
    async fetchProductTypes({ commit }, options) {
      const types = await ProductType.fetch({ ...options, _sort: 'index:ASC' })
      return types
    },
  },
}
/* eslint-enable no-unused-vars */
